let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fYNFr")).then(() => parcelRequire('9uTie'));